import { apiHostMap } from '@configs'
/**
 * 根据环境获取对应环境磐石链接
 */
const envMap: {[key in keyof typeof apiHostMap]: string} = {
  'local.tcc.testsite.woa.com': '//dev.panshi.woa.com',
  'tcc.testsite.woa.com': '//dev.panshi.woa.com',
  'tcc-pre.testsite.woa.com': '//pre.panshi.woa.com',
  'tcc.tencent.com': '//panshi.woa.com',
  'bak.tcc.tencent.com': '//panshi.woa.com',
  'tcc-web-7gwart8i0811324b-1258344699.tcloudbaseapp.com': '//panshi.woa.com',
} as const

export const getPanshiUrl = (): string => {
  return envMap[window.location.hostname] || '//panshi.woa.com'
}
